import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DirectoryProduct from 'components/DirectoryProduct';

const GetDirectoryProducts = ({ togglePopup, result }) => {
  const { data, loading, error } = result || {};

  return (
    <div className="products">
      {(data === undefined || result?.loading !== false) && (
        <span className="loader">
          <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
        </span>
      )}
      {error && <p>{'Something went wrong. Please try again.'}</p>}
      {data && data.product.length === 0 && !loading && (
        <div className="noResults">{'No results found. Please try with a different search.'}</div>
      )}
      {data &&
        data.product.length > 0 &&
        data.product.map((product) => (
          <DirectoryProduct key={JSON.stringify(product)} product={product} togglePopup={togglePopup} />
        ))}
    </div>
  );
};

export default GetDirectoryProducts;

GetDirectoryProducts.propTypes = {
  togglePopup: PropTypes.func.isRequired,
  result: PropTypes.shape({
    data: PropTypes.shape(),
    loading: PropTypes.bool,
  }),
};

GetDirectoryProducts.defaultProps = {
  result: {
    data: {},
    loading: true,
  },
};
